// jQuery(document).ready(function () {
//   jQuery("body")
//     .children()
//     .each(function () {
//       jQuery(this).html(
//         jQuery(this)
//           .html()
//           .replace(/&#8232;/g, " ")
//       );
//     });
// });
